import React, { FC, useState, useContext, useEffect } from 'react';

import ewAnalytics from '../../../utils/analytics';
import { ANALYTICS } from '../../../utils/constants/analytics';

import { ProductInfoContext } from '../../../templates/pdp';

import ComparisonContent from './ComparisonContent';
import ProductCard from './ProductCard';
import { ContentSection } from '../../../utils/types';
import { FluidObject } from 'gatsby-image';

import * as S from './styles/indexStyles';

interface ComparisonSection {
  item: Item;
  content: ContentSection;
}

type Item = {
  heading: string;
  subheading: string;
  image: FluidObject;
  number: number;
  slug: string;
  showRating: boolean;
};

export const ComparisonSection: FC<ComparisonSection> = ({ content }) => {
  const {
    title,
    headline,
    subHeadline,
    listOfContentSections,
    desktopImages,
    description,
  } = content;
  const [open, setOpen] = useState(false);
  const [leftSlug, rightSlug] = description.description.trim().split('\n');

  const productInfo = useContext(ProductInfoContext);
  const item = productInfo.productsBySlug[rightSlug];

  const handleClick = () => {
    setOpen(true);
    ewAnalytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.LABELS.PDP_UPGRADE_MODAL,
      },
    });
  };

  // NOTE: The Modal should be doing this by default, but it's not
  // I think this has to do with the fact that there are multiple
  // Modal components on the page, though I can't figure out
  // why that would matter.
  useEffect(() => {
    if (open) {
      document.documentElement.style.cssText =
        'height: 100vh; overflow: hidden';
    } else {
      document.documentElement.style.cssText = '';
    }
  }, [open]);

  return (
    <S.Container
      backgroundColor={'#d3d3d3'}
      mobileBackground={desktopImages[3].fluid}
      desktopBackground={desktopImages[2].fluid}
      data-testid={`compare-${leftSlug}-with-${rightSlug}-section`}
    >
      <S.Title>{headline}</S.Title>
      <ProductCard
        title={item.name}
        price={item.price}
        description={subHeadline}
        image={desktopImages[1].fluid}
      >
        <S.CompareButton
          appearance="secondary"
          onClick={handleClick}
          data-testid={`compare-${leftSlug}-with-${rightSlug}-cta`}
        >
          Compare Tests
        </S.CompareButton>
      </ProductCard>
      <S.Modal
        open={open}
        openHandler={setOpen}
        data-testid={`compare-${leftSlug}-with-${rightSlug}-modal`}
      >
        <ComparisonContent
          title={title}
          listOfContentSections={listOfContentSections}
          desktopImages={[desktopImages[0], desktopImages[1]]}
          leftSlug={leftSlug}
          rightSlug={rightSlug}
          setOpen={setOpen}
        />
      </S.Modal>
    </S.Container>
  );
};
